import type { PropsWithChildren } from 'react';

export interface IDialogProps {
	title: string;
	error?: string;
}

const DialogProvider = ({ children }: PropsWithChildren<IDialogProps>) => {
	return children;
};

export default DialogProvider;
